import printerws from '@/libs/thermal-printer/printerws-wrapper'
import navigatorusb from '@/libs/thermal-printer/navigatorusb-adapter'

const drivers = [
    { name: "ELGIN i9", regexMatch: /^ELGIN i9\(USB\)$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false },
    { name: "ELGIN i7", regexMatch: /^ELGIN i7\(USB\)$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false }, // chutei o nome seguindo o padrão da marca
    { name: "EPSON TM-T20", regexMatch: /^EPSON TM-T20 Receipt$/, template: "48col", specialCharacters: false, smallBuffer: false },
    { name: "Bematech MP 100S TH", regexMatch: /^MP-100S TH$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false },
    { name: "Bematech MP 2500 TH", regexMatch: /^MP-2500 TH$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false },
    { name: "Bematech MP 4000 TH", regexMatch: /^MP-4000 TH$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false }, // chutei o nome seguindo o padrão da marca
    { name: "Bematech MP 4200 TH", regexMatch: /^MP-4200 TH$/, template: "48col", header: [], specialCharacters: false, smallBuffer: false }, // chutei o nome seguindo o padrão da marca
    { name: "Generic", regexMatch: /.*/, template: "48col", header: [], specialCharacters: false, smallBuffer: false }
]
function replaceSpecialCharacters(str) {
    let string = str;
    let mapaAcentosHex = {
        a: /[\xE0-\xE6|\xAA]/g,
        A: /[\xC0-\xC6]/g,
        e: /[\xE8-\xEB]/g,
        E: /[\xC8-\xCB]/g,
        i: /[\xEC-\xEF]/g,
        I: /[\xCC-\xCF]/g,
        o: /[\xF2-\xF6|\xBA]/g,
        O: /[\xD2-\xD6]/g,
        u: /[\xF9-\xFC]/g,
        U: /[\xD9-\xDC]/g,
        c: /\xE7/g,
        C: /\xC7/g,
        n: /\xF1/g,
        N: /\xD1/g,
        ' ': /\xA0/g
    };

    for (let letra in mapaAcentosHex) {
        let expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
    }

    return string;
}
function stringToByteArray(str) {
    let out = [], p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        } else if (
            ((c & 0xFC00) === 0xD800) && (i + 1) < str.length &&
            ((str.charCodeAt(i + 1) & 0xFC00) === 0xDC00)) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03FF) << 10) + (str.charCodeAt(++i) & 0x03FF);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        } else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
}

export default {
    namespaced: true,
    state: {
        adapterName: null,
        printerWrapper: null,
        id: null,
        name: null,
        cutPaper: false
    },
    getters: {
        driver: state => {
            let name = state.name || ""
            for (let i in drivers) {
                if (name.match(drivers[i].regexMatch)) {
                    return drivers[i]
                }
            }
            throw new Error("Driver não encontrado")
        },
        configured: state => {
            return !!state.id
        },
        adapterName: state => state.adapterName,
        id: state => state.id,
        name: state => state.name,
        cutPaper: state => state.cutPaper,
        adapter: state => {
            if (state.adapterName === "printerws") {
                return printerws
            } else {
                return navigatorusb
            }
        }
    },
    mutations: {
        setAdapterName(state, adapterName) {
            state.adapterName = adapterName
            state.printerWrapper = adapterName === "printerws" ? printerws : navigatorusb
        },
        setDefault(state, {adapterName, id, name, cutPaper}) {
            state.adapterName = adapterName
            state.id = id
            state.name = name
            state.cutPaper = cutPaper

            localStorage.setItem('thermal_printer_adapter', adapterName)
            localStorage.setItem('thermal_printer_id', id)
            localStorage.setItem('thermal_printer_name', name)
            localStorage.setItem('thermal_printer_cut_paper', cutPaper)
        },
    },
    actions: {
        async init({state}) {
            if (localStorage.getItem('thermal_printer_id') && !localStorage.getItem('thermal_printer_adapter')) {
                localStorage.setItem('thermal_printer_adapter', "printerws")
            }

            state.adapterName = localStorage.getItem('thermal_printer_adapter') || "navigatorusb"
            if (state.adapterName === "printerws") {
                state.printerWrapper = printerws
            } else {
                state.printerWrapper = navigatorusb
            }
            state.id = localStorage.getItem('thermal_printer_id')
            state.name = localStorage.getItem('thermal_printer_name')
            state.cutPaper = localStorage.getItem('thermal_printer_cut_paper') === "true"
        },
        prepare({state}, str) {
            str = str.replace(/<!--.*?-->/g, "");
            str = str.replace(/\n/g, " ");
            str = str.replace(/ +/g, " ");
            str = str.replace(/{br}/g, "\n");
            str = str.split("\n");
            str = str.map(row => row.trim());
            str = str.join("\n");
            str = str.concat("\n")
            if (!state.cutPaper) {
                str = str.concat("\n\n\n\n\n\n\n")
            }
            return str;
        },
        async print({state, getters}, txt) {
            if (!getters.adapter) {
                throw new Error("Não foi possível imprimir")
            }

            const adapter = getters.adapter
            const driver = getters.driver

            if (!driver.specialCharacters) {
                txt = replaceSpecialCharacters(txt)
            }

            const alreadyConnected = await adapter.isConnected()
            if (!alreadyConnected) {
                await adapter.connect(state.id)
            }

            if (driver.smallBuffer) {
                if (driver.header.length) {
                    await adapter.write(driver.header)
                }
                let lines = txt.split(`\n`)
                for (const line of lines) {
                    await new Promise(resolve => {
                        setTimeout(() => {
                            resolve()
                        }, 100)
                    })

                    await adapter.write(stringToByteArray(`${line}\n`))
                }
                if (state.cutPaper) {
                    await adapter.write([0x1D, 0x56, 0x41, 0x0])
                }
            } else {
                let byteArray = [];
                byteArray = byteArray.concat(driver.header);
                byteArray = byteArray.concat(stringToByteArray(txt));
                if (state.cutPaper) {
                    byteArray = byteArray.concat([0x1D, 0x56, 0x41, 0x0]);
                }

                await adapter.write(byteArray).catch(async err => {
                    if (!alreadyConnected) {
                        await adapter.disconnect()
                    }
                    throw err
                })
            }

            if (!alreadyConnected) {
                await adapter.disconnect().catch(() => {
                })
            }
        },
        async printTemplate({dispatch}, tpl) {
            const txt = await dispatch('prepare', tpl)
            return await dispatch('print', txt)
        },
        async list({getters}, adapterName) {
            if (!adapterName) {
                adapterName = getters.adapterName
            }
            const adapter = adapterName === "printerws" ? printerws : navigatorusb
            return await adapter.list()
        },
        async findNewDevice({getters}, adapterName) {
            if (!adapterName) {
                adapterName = getters.adapterName
            }
            const adapter = adapterName === "printerws" ? printerws : navigatorusb
            if (adapter !== navigatorusb) {
                return null
            }
            return await adapter.findNewDevice()
        },
        async connect({state, getters}) {
            if(!getters.adapter){
                throw new Error("Não conseguimos nos conectar com a impressora")
            }
            return await getters.adapter.connect(state.id).catch(() => {
                throw new Error("Não conseguimos nos conectar com a impressora")
            })
        },
        async disconnect({getters}) {
            if(!getters.adapter){
                return
            }
            return await getters.adapter.disconnect().catch(() => {})
        },
        async testConnection({state, getters}) {
            if(!getters.adapter){
                return false
            }
            try {
                await getters.adapter.connect(state.id)
                await getters.adapter.disconnect()
                return true
            } catch (e) {
                return false
            }
        },
    }
}
